module.exports = "/_next/static/images/sebastian-martinez-1809679599fc9f5183c5a1ee4d99b81e.png";